const PROFILE_PHOTO_KEYS = [
  'displayImage',
  'profileImage',
  'profilePhoto',
  'photo',
  'photoUrl',
]

/** First non-empty profile photo URL on user/API payload. */
export const resolveProfilePhoto = (source = {}) => {
  for (const key of PROFILE_PHOTO_KEYS) {
    const value = source?.[key]
    if (typeof value === 'string' && value.trim()) return value.trim()
  }
  return null
}

/** Keep `displayImage` + `profileImage` in sync for header avatar and forms. */
export const withNormalizedProfilePhoto = (user = {}) => {
  const photo = resolveProfilePhoto(user)
  if (!photo) return user
  return {
    ...user,
    displayImage: user.displayImage || photo,
    profileImage: user.profileImage || photo,
  }
}
